module.exports = __webpack_public_path__ + "static/media/runners.1741fb15.jpg";